/* Silk Scarfs - pop-up de bienvenue (section ss-welcome, 25-26/10). Reglages = recherche du 26/10.
   - Ouverture : delai ET premier geste (defilement, clic, touche) : la fenetre ne vole pas le LCP et ne
     s'affiche qu'aux visiteuses actives. Mobile 1re page : bandeau en bas apres X s + Y % de defilement ;
     pages suivantes : plein ecran. Ordinateur : fenetre (carte en coin sur la 1re page venue d'une annonce
     Google), + sortie de la souris.
   - Etat (localStorage « ssWelcome:v2 ») : { s: closed | revealed | done, t: derniere fermeture, h: [fermetures] }.
     Fermee : pause de N jours (30 jours apres 2 fermetures en 7 jours). Inscrite : plus jamais.
     Une seule ouverture automatique par visite. Rappel en bas a gauche apres une fermeture.
   - Jamais : visite venue d'un e-mail / SMS (utm), panier non vide, ajout au panier sur la page, autre fenetre ouverte.
   - Evenements Shopify : ss:popup_view, ss:popup_close, ss:popup_signup (+ gtag generate_lead).
     ?ss_wp_test=1 : aucun evenement, aucun code enregistre (pour tester sans fausser les chiffres). */
(function () {
  'use strict';
  var KEY = 'ssWelcome:v2';
  var PV = 'ssWelcome:pv';
  var SRC = 'ssWelcome:src';
  var SHOWN = 'ssWelcome:shown';
  var PENDING = 'ssWelcome:pending';
  var TEASER_OFF = 'ssWelcome:tx';
  var HOLD = 'ssWelcome:hold';
  var THRESHOLD = 0.3;
  var DAY = 864e5;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var quiet = /[?&]ss_wp_test=1/.test(location.search);

  function lget(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lset(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function sdel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function num(v, fb) { var n = parseFloat(v); return isNaN(n) ? fb : n; }

  // source de la visite, lue sur la 1re page de la session
  if (sget(SRC) === null) {
    var q = location.search;
    var src = /[?&](utm_source=omnisend|utm_medium=(email|sms))/i.test(q) ? 'email'
      : (/[?&](gclid|gbraid|wbraid|gad_source|srsltid)=/i.test(q) || /[?&]utm_medium=cpc/i.test(q)) ? 'ads' : '';
    sset(SRC, src);
  }

  // ajout au panier pendant cette page vue (formulaire ou appel /cart/add) -> pas d'ouverture automatique
  var addedToCart = false;
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.action && /\/cart\/add/.test(e.target.action)) addedToCart = true;
  }, true);
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (en) { if (/\/cart\/add/.test(en.name)) addedToCart = true; });
    }).observe({ type: 'resource', buffered: true });
  } catch (e) {}

  function init(root) {
    if (!root || root.__ssWp) return;
    root.__ssWp = true;

    var d = root.dataset;
    var id = d.section;
    var design = d.design === 'true';
    var silent = design || quiet;
    var code = d.code || '';
    var dialog = root.querySelector('.ss-wp__dialog');
    var steps = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-step]'), function (el) { steps[el.getAttribute('data-step')] = el; });
    var card = root.querySelector('[data-card]');
    var foil = root.querySelector('[data-foil]');
    var after = root.querySelector('[data-after]');
    var live = root.querySelector('[data-live]');
    var form = root.querySelector('form');
    var input = form && form.querySelector('input[type="email"]');
    var err = root.querySelector('[data-error]');
    var submit = form && form.querySelector('[type="submit"]');
    var copyBtn = root.querySelector('[data-copy-btn]');
    var codeEl = root.querySelector('[data-code-v]');
    var shopBtn = root.querySelector('[data-shop]');
    var teaser = document.querySelector('[data-ss-wp-teaser="' + id + '"]');
    var teaserOpen = teaser && teaser.querySelector('[data-teaser-open]');

    var isOpen = false;
    var mode = 'full';
    var revealed = false;
    var step = 'scratch';
    var lastFocus = null;
    var ctx = null;
    var drawing = false;
    var last = null;
    var checkTimer = 0;
    var paintedW = 0;
    var advanceTimer = 0;
    var applied = false;

    if (form) form.noValidate = true;

    function state() { return lget(KEY) || {}; }
    function save(s) {
      if (design) return;
      var st = state();
      var now = Date.now();
      var h = (st.h || []).filter(function (t) { return now - t < 30 * DAY; });
      if (s === 'closed' || s === 'revealed') h.push(now);
      lset(KEY, { s: s, t: now, h: h, e: (s === 'revealed' && (st.e || reachedEmail)) ? 1 : 0 });
    }
    function publish(name, extra) {
      if (silent) return;
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          var data = { mode: mode, step: step, page_type: d.pageType || '', source: sget(SRC) || '', group: lget(HOLD) || 'popup' };
          if (extra) Object.keys(extra).forEach(function (k) { data[k] = extra[k]; });
          Shopify.analytics.publish(name, data);
        }
      } catch (e) {}
    }

    function show(name) {
      step = name;
      Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== name; });
    }

    /* ---------- ouverture / fermeture ---------- */
    function setMode(m) {
      mode = m;
      root.classList.toggle('is-sheet', m === 'sheet');
      dialog.setAttribute('aria-modal', m === 'sheet' ? 'false' : 'true');
      document.documentElement.classList.toggle('ss-wp-lock', isOpen && m !== 'sheet');
    }
    function focusables() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
        visible
      );
    }
    function focusStep() {
      if (mode === 'sheet') return; // le bandeau ne prend pas le focus : la page reste au premier plan
      var target = dialog;
      if (step === 'email' && input) target = input;
      else if (step === 'done' && copyBtn) target = copyBtn;
      try { target.focus({ preventScroll: true }); } catch (e) {}
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab' || mode === 'sheet') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var lastEl = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }

    function open(name, opts) {
      if (!root.isConnected) return;
      opts = opts || {};
      show(name || 'scratch');
      if (isOpen) {
        setMode(opts.mode || mode);
        if (step === 'scratch') { if (opts.revealed) reveal(true); else if (!revealed) paintWhenReady(); }
        focusStep();
        return;
      }
      isOpen = true;
      lastFocus = document.activeElement;
      // bandeau seulement vu (ni ferme ni agrandi) : la fenetre complete reste possible a la page suivante
      if (!design && !(sget(SHOWN) === '1')) sset(SHOWN, (opts.mode || 'full') === 'sheet' ? 'sheet' : '1');
      Array.prototype.forEach.call(root.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; });
      if (teaser) teaser.hidden = true;
      root.hidden = false;
      placeTeaser();
      setMode(opts.mode || 'full');
      document.addEventListener('keydown', onKey);
      window.addEventListener('resize', onResize);
      // lecture de la mise en page = style calcule : la transition joue sans requestAnimationFrame
      void root.offsetWidth;
      root.classList.add('is-open');
      if (step === 'scratch') {
        if (opts.revealed || revealed) reveal(true);
        else paintWhenReady();
      }
      focusStep();
      publish('ss:popup_view', { trigger: opts.trigger || 'auto' });
    }

    // bandeau -> plein ecran, apres un geste de la cliente (gratter, toucher)
    function expand() {
      if (!isOpen || mode !== 'sheet') return;
      if (!design) sset(SHOWN, '1');
      setMode('full');
      if (!revealed) paintWhenReady();
      focusStep();
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      clearTimeout(advanceTimer);
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
      document.documentElement.classList.remove('ss-wp-lock');
      if (reduce) root.hidden = true;
      else setTimeout(function () { if (!isOpen) root.hidden = true; }, 380);
      if (design) {
        showTeaser();
      } else if (state().s !== 'done') {
        save(revealed ? 'revealed' : 'closed');
        showTeaser();
        publish('ss:popup_close');
      }
      if (lastFocus && lastFocus.focus && mode !== 'sheet') { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }

    function showTeaser() {
      if (!teaser || isOpen || d.teaser !== 'true') return;
      if (design) {
        // editeur de theme : on montre le bouton pour pouvoir le voir et le regler (rien n'est memorise)
        if (teaserOpen) teaserOpen.textContent = revealed ? (d.teaserPost || '') : (d.teaserPre || '');
        teaser.hidden = false;
        placeTeaser();
        return;
      }
      if (lget(TEASER_OFF)) return;
      var st = state();
      if (st.s === 'done') return;
      if (teaserOpen) teaserOpen.textContent = st.s === 'revealed' ? (d.teaserPost || '') : (d.teaserPre || '');
      teaser.hidden = false;
      placeTeaser();
      // la barre d'apercu de Shopify peut arriver apres le chargement du script
      setTimeout(placeTeaser, 1500);
      setTimeout(placeTeaser, 4000);
    }
    // Ce qui occupe deja le bas de l'ecran : barre d'achat collante des fiches (.ss-sbar.is-on) et barre
    // d'apercu de Shopify (apercu du theme seulement). Le bandeau et le rappel se placent AU-DESSUS :
    // ils ne doivent jamais couvrir « Add to bag ».
    var sbar = document.querySelector('[data-ss-sbar]');
    function bottomLift() {
      var lift = 0;
      var vh = window.innerHeight;
      var pbar = document.getElementById('PBarNextFrameWrapper');
      if (pbar) {
        var r = pbar.getBoundingClientRect();
        if (r.height > 0 && r.top < vh && r.bottom > vh - 4) lift = Math.max(lift, Math.round(vh - r.top));
      }
      if (sbar && sbar.classList.contains('is-on')) {
        var r2 = sbar.getBoundingClientRect();
        if (r2.height > 0) lift = Math.max(lift, Math.round(r2.height));
      }
      return lift;
    }
    function placeTeaser() {
      var l = bottomLift() + 'px';
      root.style.setProperty('--wp-lift', l);
      if (teaser) teaser.style.setProperty('--wp-tease-lift', l);
    }
    if (sbar && window.MutationObserver) {
      // la barre d'achat apparait / disparait au defilement : on suit sa classe is-on
      new MutationObserver(function () { placeTeaser(); setTimeout(placeTeaser, 350); }).observe(sbar, { attributes: true, attributeFilter: ['class'] });
    }

    /* ---------- la « soie » a gratter ---------- */
    function cssVar(name, fallback) {
      var v = getComputedStyle(root).getPropertyValue(name).trim();
      return v || fallback;
    }
    function paintWhenReady() {
      var hf = cssVar('--font-heading--family', 'serif');
      var p = document.fonts && document.fonts.load ? document.fonts.load('italic 400 32px ' + hf).catch(function () {}) : Promise.resolve();
      Promise.race([p, new Promise(function (r) { setTimeout(r, 700); })]).then(paint);
    }
    function diamond(c, x, y, r) {
      c.beginPath(); c.moveTo(x, y - r); c.lineTo(x + r, y); c.lineTo(x, y + r); c.lineTo(x - r, y); c.closePath(); c.fill();
    }
    function fitFont(c, text, style, size, family, maxW, min) {
      var s = size;
      c.font = style + ' ' + s + 'px ' + family;
      while (s > min && c.measureText(text).width > maxW) { s -= 1; c.font = style + ' ' + s + 'px ' + family; }
      return s;
    }
    function paint() {
      if (!foil || revealed) return;
      var rect = foil.getBoundingClientRect();
      if (!rect.width) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = rect.width;
      var h = rect.height;
      var small = w < 200;
      foil.width = Math.round(w * dpr);
      foil.height = Math.round(h * dpr);
      ctx = foil.getContext('2d', { willReadFrequently: true });
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      paintedW = w;

      var c1 = cssVar('--wp-foil-1', '#1B2139');
      var c2 = cssVar('--wp-foil-2', '#3B467A');
      var line = cssVar('--wp-foil-line', '#D9C39A');
      var hf = cssVar('--font-heading--family', 'serif');
      var bf = cssVar('--font-body--family', 'sans-serif');
      var m = small ? 5.5 : 10.5;

      // satin : degrade + reflet en diagonale
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, c1); g.addColorStop(0.42, c2); g.addColorStop(0.58, c2); g.addColorStop(1, c1);
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      var s = ctx.createLinearGradient(0, h, w, 0);
      s.addColorStop(0.2, 'rgba(255,255,255,0)');
      s.addColorStop(0.46, 'rgba(255,255,255,0.13)');
      s.addColorStop(0.52, 'rgba(255,255,255,0.22)');
      s.addColorStop(0.6, 'rgba(255,255,255,0)');
      ctx.fillStyle = s; ctx.fillRect(0, 0, w, h);
      // armure serge (twill) : fines diagonales
      ctx.save();
      ctx.strokeStyle = 'rgba(255,255,255,0.055)';
      ctx.lineWidth = 1;
      for (var x = -h; x < w; x += 3.5) { ctx.beginPath(); ctx.moveTo(x, h); ctx.lineTo(x + h, 0); ctx.stroke(); }
      ctx.restore();
      // ourlet : double cadre + losanges aux coins, comme la bordure d'un carre de soie
      ctx.strokeStyle = line; ctx.fillStyle = line;
      ctx.globalAlpha = 0.9; ctx.lineWidth = small ? 1 : 1.25; ctx.strokeRect(m, m, w - 2 * m, h - 2 * m);
      if (!small) { ctx.globalAlpha = 0.5; ctx.lineWidth = 0.75; ctx.strokeRect(m + 5, m + 5, w - 2 * m - 10, h - 2 * m - 10); }
      ctx.globalAlpha = 0.9;
      [[m, m], [w - m, m], [m, h - m], [w - m, h - m]].forEach(function (p) { diamond(ctx, p[0], p[1], small ? 2.5 : 4); });
      // texte, ajuste a la largeur
      ctx.globalAlpha = 1;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var label = d.foilLabel || '';
      var hint = (d.foilHint || '').toUpperCase();
      fitFont(ctx, label, 'italic 400', Math.round(h * (small ? 0.2 : 0.15)), hf, w - 4 * m, 9);
      ctx.fillText(label, w / 2, small ? h / 2 : h * 0.45);
      if (!small && hint) {
        if ('letterSpacing' in ctx) ctx.letterSpacing = '3px';
        var hs = fitFont(ctx, hint, '600', Math.max(10, Math.round(h * 0.05)), bf, w - 6 * m, 9);
        if (hs >= 9) { ctx.globalAlpha = 0.85; ctx.fillText(hint, w / 2, h * 0.64); }
        if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
        ctx.globalAlpha = 1;
      }
      // pret a gratter
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = small ? Math.max(18, w * 0.16) : Math.max(30, w * 0.12);
      ctx.strokeStyle = '#000';
      ctx.fillStyle = '#000';
    }
    function onResize() {
      if (!revealed && foil && Math.abs(foil.getBoundingClientRect().width - paintedW) > 30) paint();
    }
    function point(e) {
      var r = foil.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    function dot(p) { ctx.beginPath(); ctx.arc(p.x, p.y, ctx.lineWidth / 2, 0, Math.PI * 2); ctx.fill(); }
    function line(a, b) { ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke(); }
    function scheduleCheck() { if (!checkTimer) checkTimer = setTimeout(function () { checkTimer = 0; check(); }, 350); }
    // part grattee, mesuree sur un echantillon (1 pixel sur 16) : peu de travail pour le navigateur
    function check() {
      if (revealed || !ctx) return;
      var data;
      try { data = ctx.getImageData(0, 0, foil.width, foil.height).data; } catch (e) { return; }
      var clear = 0;
      var total = 0;
      for (var i = 3; i < data.length; i += 64) { total++; if (data[i] < 40) clear++; }
      if (total && clear / total >= THRESHOLD) reveal();
    }
    if (foil) {
      foil.addEventListener('pointerdown', function (e) {
        if (revealed || !ctx) return;
        e.preventDefault(); // pas de selection de texte ni de defilement pendant le grattage
        drawing = true;
        last = point(e);
        dot(last);
        try { foil.setPointerCapture(e.pointerId); } catch (x) {}
      });
      foil.addEventListener('pointermove', function (e) {
        if (revealed || !ctx) return;
        var p = point(e);
        if (drawing || e.pointerType === 'mouse') {
          if (last) line(last, p); else dot(p);
          last = p;
          if (!drawing) scheduleCheck(); // souris qui survole : verification espacee
        }
      });
      var end = function () { if (drawing) { drawing = false; check(); } };
      foil.addEventListener('pointerup', end);
      foil.addEventListener('pointercancel', end);
      foil.addEventListener('pointerleave', function () { last = null; end(); });
    }

    function reveal(instant) {
      if (revealed && !instant) return;
      revealed = true;
      if (card) {
        card.classList.toggle('is-instant', !!instant);
        card.classList.add('is-revealed');
      }
      root.classList.add('is-revealed');
      if (after) after.hidden = false;
      if (instant) return;
      if (live) live.textContent = d.liveText || '';
      if (!design && state().s !== 'done') { var st = state(); lset(KEY, { s: 'revealed', t: st.t || 0, h: st.h || [], e: st.e || 0 }); }
      if (mode === 'sheet') expand();
      // l'offre revelee reste affichee : la cliente clique sur « Claim my 20% » pour passer a l'e-mail (choix du client)
      var btn = after && after.querySelector('[data-claim]');
      if (btn) setTimeout(function () { try { btn.focus({ preventScroll: true }); } catch (e) {} }, 450);
    }

    // passage a l'etape e-mail ; on memorise que la cliente l'a atteinte (la reouverture y revient directement)
    var reachedEmail = false;
    function goEmail() {
      reachedEmail = true;
      show('email');
      if (!design) { var st = state(); if (st.s !== 'done') lset(KEY, { s: 'revealed', t: st.t || 0, h: st.h || [], e: 1 }); }
      setTimeout(focusStep, 30);
    }
    // etape a laquelle on rouvre (rappel, nouvelle ouverture automatique) : jamais une offre revelee sans bouton
    function reopenStep() {
      var st = state();
      var rev = revealed || st.s === 'revealed';
      if (!rev) return { name: 'scratch', revealed: false };
      revealed = true;
      if (reachedEmail || st.e) return { name: 'email', revealed: true };
      return { name: 'scratch', revealed: true };
    }

    /* ---------- e-mail ---------- */
    function fail(msg) {
      sdel(PENDING);
      if (submit) submit.removeAttribute('aria-busy');
      if (err) { err.textContent = msg; err.hidden = false; }
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    }
    function success() {
      sdel(PENDING);
      if (submit) submit.removeAttribute('aria-busy');
      if (!design) lset(KEY, { s: 'done', t: Date.now(), h: [] });
      if (teaser) teaser.hidden = true;
      show('done');
      if (!silent && code) {
        // enregistre le code pour la caisse de cet appareil (meme effet que le lien /discount/CODE)
        try {
          fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
            .then(function (r) { applied = r.ok; })
            .catch(function () {});
        } catch (e) {}
      }
      if (!silent) {
        try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { lead_source: 'popup' }); } catch (e) {}
        publish('ss:popup_signup');
      }
      setTimeout(focusStep, 60);
    }
    // Envoi CLASSIQUE (pas de fetch) : l'anti-robot de Shopify (hCaptcha, charge au premier clic dans le champ)
    // intercepte l'envoi et soumet lui-meme le formulaire. On passe AVANT lui (capture sur window, pose au
    // chargement) : e-mail invalide -> on bloque et on affiche l'erreur ; valide -> on note l'inscription en
    // cours et on laisse Shopify envoyer. Au retour sur la meme page, la pop-up se rouvre sur le code.
    if (form) {
      window.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        if (err) err.hidden = true;
        if (input) input.removeAttribute('aria-invalid');
        if (design) { e.preventDefault(); e.stopImmediatePropagation(); success(); return; }
        var v = (input && input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          fail(d.errEmail || '');
          return;
        }
        sset(PENDING, '1');
        if (submit) submit.setAttribute('aria-busy', 'true');
      }, true);
      if (input) {
        // clavier du telephone ouvert : garder le champ et le bouton visibles
        input.addEventListener('focus', function () {
          if (window.matchMedia('(max-width: 749px)').matches) setTimeout(function () { try { input.scrollIntoView({ block: 'center' }); } catch (e) {} }, 300);
        });
      }
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var done = function () {
          copyBtn.textContent = d.copied || 'Copied';
          setTimeout(function () { copyBtn.textContent = d.copy || 'Copy'; }, 2000);
        };
        var fallback = function () {
          try {
            var r = document.createRange();
            r.selectNodeContents(codeEl);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(r);
            document.execCommand('copy');
            done();
          } catch (e) {}
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback);
        else fallback();
      });
    }
    if (shopBtn) {
      // code deja enregistre -> on ferme et la cliente reste sur sa page ; sinon le lien l'enregistre et revient ici
      shopBtn.addEventListener('click', function (e) { if (applied) { e.preventDefault(); close(); } });
    }

    /* ---------- boutons ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ss-wp-close], [data-reveal], [data-claim]');
      if (!t || !root.contains(t)) {
        // toucher le bandeau (hors carte et croix) l'agrandit
        if (mode === 'sheet' && e.target.closest('.ss-wp__step') && !e.target.closest('[data-foil]')) expand();
        return;
      }
      if (t.hasAttribute('data-ss-wp-close')) { close(); return; }
      if (t.hasAttribute('data-reveal')) { reveal(); return; }
      if (t.hasAttribute('data-claim')) goEmail();
    });
    if (teaser) {
      teaser.addEventListener('click', function (e) {
        if (e.target.closest('[data-teaser-x]')) { teaser.hidden = true; if (!design) lset(TEASER_OFF, 1); return; }
        if (e.target.closest('[data-teaser-open]')) {
          var to = reopenStep();
          open(to.name, { mode: 'full', revealed: to.revealed, trigger: 'teaser' });
        }
      });
    }

    /* ---------- editeur de theme ---------- */
    function preview() {
      var p = d.preview || 'scratch';
      if ((p === 'scratch' || p === 'sheet') && revealed) {
        revealed = false;
        if (card) card.classList.remove('is-revealed', 'is-instant');
        root.classList.remove('is-revealed');
        if (after) after.hidden = true;
      }
      if (p === 'teaser') { close(); if (!isOpen) showTeaser(); return; }
      if (teaser) teaser.hidden = true;
      if (p === 'sheet') open('scratch', { mode: 'sheet' });
      else open(p === 'revealed' ? 'scratch' : p, { mode: 'full', revealed: p === 'revealed' });
    }
    if (design) {
      document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === id && root.isConnected) preview(); });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === id && root.isConnected) { close(); if (teaser) teaser.hidden = true; }
      });
      root.__ssWpPreview = preview;
      return;
    }

    /* ---------- retour apres l'envoi du formulaire ---------- */
    var qs = location.search;
    if (sget(PENDING)) {
      var posted = form && form.querySelector('[data-posted="true"]');
      if (err && !err.hidden && err.textContent.trim()) { sdel(PENDING); revealed = true; open('email', { mode: 'full', trigger: 'return' }); return; }
      if (posted || /customer_posted=true/.test(qs) || (form && location.hash === '#' + form.id)) {
        revealed = true;
        open('done', { mode: 'full', trigger: 'return' });
        success();
        return;
      }
      sdel(PENDING);
    }

    /* ---------- groupe temoin ---------- */
    var hold = num(d.holdout, 0);
    if (hold > 0) {
      var g = lget(HOLD);
      if (!g) { g = Math.random() * 100 < hold ? 'holdout' : 'popup'; lset(HOLD, g); }
      if (g === 'holdout') { if (!sget(SHOWN)) { sset(SHOWN, 'h'); publish('ss:popup_holdout'); } return; }
    }

    /* ---------- ouverture automatique ---------- */
    var pv = (parseInt(sget(PV) || '0', 10) || 0) + 1;     // pages vues dans la visite
    sset(PV, String(pv));
    var st = state();
    if (st.s === 'done') return;
    if (st.s === 'closed' || st.s === 'revealed') showTeaser();
    if ((sget(SRC) || '') === 'email') return;            // abonnee qui arrive d'un e-mail ou d'un SMS
    if (/customer_posted=true/.test(qs)) return;           // inscription par un autre formulaire sur cette page
    if (sget(SHOWN) === '1') return;                       // une seule fenetre complete automatique par visite
    if (num(d.cart, 0) > 0) return;                        // panier deja rempli : elle achete, on ne la derange pas
    if (st.t && (st.s === 'closed' || st.s === 'revealed')) {
      var now = Date.now();
      var recent = (st.h || []).filter(function (t) { return now - t < 7 * DAY; });
      var wait = recent.length >= 2 ? 30 * DAY : num(d.snooze, 3) * DAY;
      if (now - st.t < wait) return;
    }

    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var first = pv === 1;
    var autoMode = 'full';
    if (mobile && first && d.mMode !== 'full') autoMode = 'sheet';
    if (!mobile && first && sget(SRC) === 'ads' && d.adsSheet === 'true') autoMode = 'sheet';
    var delay = mobile ? (first ? num(d.delayM, 6) : num(d.delayM2, 3)) : num(d.delayD, 8);
    var needScroll = mobile && first ? num(d.mScroll, 30) : 0;
    var timeOk = false;
    var acted = false;
    var gone = false;

    // une autre fenetre (panier, menu, recherche) vraiment ouverte ? Les tiroirs du theme gardent
    // aria-modal="true" meme fermes (visibility: hidden) : on regarde le style calcule et la taille.
    function reallyOpen(el) {
      if (!el || root.contains(el)) return false;
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
      var r = el.getBoundingClientRect();
      return r.width > 120 && r.height > 120 && r.right > 0 && r.bottom > 0 && r.left < window.innerWidth && r.top < window.innerHeight;
    }
    function tryOpen(m, trigger) {
      if (gone || isOpen || addedToCart || sget(SHOWN) === '1') return;
      if (m === 'sheet' && sget(SHOWN) === 'sheet') return; // bandeau deja montre dans la visite : pas deux fois
      var others = document.querySelectorAll('dialog[open], [aria-modal="true"]');
      for (var i = 0; i < others.length; i++) {
        if (reallyOpen(others[i])) { setTimeout(function () { tryOpen(m, trigger); }, 4000); return; }
      }
      gone = true;
      stopListening();
      var to = reopenStep();
      open(to.name, { mode: to.revealed ? 'full' : m, revealed: to.revealed, trigger: trigger });
    }
    function scrolledEnough() {
      if (!needScroll) return true;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return true;
      return (window.scrollY / max) * 100 >= needScroll;
    }
    function attempt() {
      if (!acted && window.scrollY > 0) acted = true; // la page a deja defile = geste deja fait
      if (timeOk && acted && scrolledEnough()) tryOpen(autoMode, 'auto');
    }
    function onAct() { acted = true; attempt(); }
    var actEvents = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
    function stopListening() { actEvents.forEach(function (ev) { window.removeEventListener(ev, onAct, { passive: true }); }); }
    actEvents.forEach(function (ev) { window.addEventListener(ev, onAct, { passive: true }); });
    setTimeout(function () { timeOk = true; attempt(); }, delay * 1000);

    if (!mobile && d.exit === 'true') {
      var onOut = function (e) {
        if (e.relatedTarget || e.clientY > 0) return;
        document.removeEventListener('mouseout', onOut);
        tryOpen('full', 'exit');
      };
      setTimeout(function () { document.addEventListener('mouseout', onOut); }, 3000);
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ss-wp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // editeur : la section est re-rendue a chaque reglage modifie -> on la rouvre sur l'etape choisie
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-ss-wp]');
    if (!root) return;
    init(root);
    if (root.__ssWpPreview) root.__ssWpPreview();
  });
})();
